import { useEffect, useState } from 'react';
import style from './Clock.module.css';

const dayNames = ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag'];
const monthNames = ['januar', 'februar', 'mars', 'april', 'mai', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'desember'];

export default function Clock() {
    const [now, setNow] = useState(() => new Date());

    useEffect(() => {
        // align ticks to the next second so the colon-blink stays steady
        const start = setTimeout(() => {
            setNow(new Date());
            const id = setInterval(() => setNow(new Date()), 1000);
            (start as any)._id = id;
        }, 1000 - (Date.now() % 1000));
        return () => {
            clearTimeout(start);
            if ((start as any)._id) clearInterval((start as any)._id);
        };
    }, []);

    const hh = String(now.getHours()).padStart(2, '0');
    const mm = String(now.getMinutes()).padStart(2, '0');
    const day = dayNames[now.getDay()];
    const date = now.getDate();
    const month = monthNames[now.getMonth()];
    const year = now.getFullYear();

    const showColon = now.getSeconds() % 2 === 0;

    return (
        <div className={style.clock}>
            <div className={style.kicker}>Fredrikstad</div>
            <div className={style.time} aria-label={`${hh}:${mm}`}>
                <span className={style.digit}>{hh}</span>
                <span className={`${style.colon} ${showColon ? '' : style.colonHidden}`}>:</span>
                <span className={style.digit}>{mm}</span>
            </div>
            <div className={style.date}>
                {day.charAt(0).toUpperCase() + day.slice(1)} {date}. {month} {year}
            </div>
        </div>
    );
}
